import { api } from '@services';

interface IRequest {
  ids: string[];
}

const deleteMassEquipments = async ({ ids }: IRequest): Promise<void> => {
  await api.delete(`/equipments/mass?ids=${ids.join(',')}`);
};

export { deleteMassEquipments };
